import {inject, Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {first, mergeMap} from 'rxjs';
import {AuthService} from '@aviary/services/auth.service';
import {API_URL} from '@aviary/injection-tokens/app-provided.tokens';

@Injectable()
export class JwtTokenInterceptor implements HttpInterceptor {
  private readonly authService: AuthService = inject(AuthService);
  private readonly apiUrl: string = inject(API_URL);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    const apiOrigin = new URL(this.apiUrl).origin;

    // Actuator call requires unique URL as it does not include the API prefix.
    const isApiCall =
      req.url.startsWith(this.apiUrl) ||
      req.url.startsWith(`${apiOrigin}/actuator`);

    if (!isApiCall) {
      return next.handle(req);
    }

    return this.authService.getAsyncToken().pipe(
      first(),
      mergeMap(token => {
        if (!token) {
          return next.handle(req);
        }

        const authReq = req.clone({
          setHeaders: {Authorization: 'Bearer ' + token},
        });

        return next.handle(authReq);
      }),
    );
  }
}
